<div mat-dialog-title>
    <h3 class="text-primary-500 text-2xl font-bold">Channel Naming Guidelines</h3>
</div>
<div mat-dialog-content>
    <p class="text-primary-300 text-sm mb-2">
        Choosing an effective and memorable name for your media content channel is crucial for attracting listeners and
        building your brand. To help you create a compelling Channel name, consider the following naming standards:
    </p>

    <p class="text-primary-500 font-semibold mb-1">Keep it Succinct and Memorable:</p>
    <p class="text-primary-300 text-sm mb-2">
        Channel names should be concise and memorable, making it easier for listeners to recall and share with others.
        Avoid excessively long or convoluted names that may be challenging to remember or pronounce.</p>

    <p class="text-primary-500 font-semibold mb-1">Reflect the Content or Theme:</p>
    <p class="text-primary-300 text-sm mb-2">
        The Channel name should provide a clear indication of the content or theme of the show. Choose a name that
        accurately represents the topics discussed, ensuring that potential listeners can easily understand what to
        expect.</p>

    <p class="text-primary-500 font-semibold mb-1">Consider Searchability:</p>
    <p class="text-primary-300 text-sm mb-2">
        Optimize the Channel name for searchability within the app and search engines. Incorporate relevant keywords
        that potential viewers/listeners might use when searching for Christian media, making it easier for them to find
        your show.</p>

    <p class="text-primary-500 font-semibold mb-1">Use Language That Resonates:</p>
    <p class="text-primary-300 text-sm mb-2">
        Select language that resonates with your target audience. Consider the tone and messaging that will appeal to
        Christian listeners, highlighting the values, faith, and spiritual growth they seek.</p>

    <p class="text-primary-500 font-semibold mb-1">Avoid Ambiguity and Misleading Titles:</p>
    <p class="text-primary-300 text-sm mb-2">
        Ensure that the Channel name is clear and avoids ambiguity or confusion. It should not mislead listeners or
        create false expectations about the content or purpose of the show.</p>

    <p class="text-primary-500 font-semibold mb-1">Reflect Christian Values:</p>
    <p class="text-primary-300 text-sm mb-2">
        The Channel name should align with Christian values, promoting messages of love, compassion, faith, and hope.
        It should not contradict or undermine the principles of Christian faith.</p>

    <p class="text-primary-500 font-semibold mb-1">Originality and Uniqueness:</p>
    <p class="text-primary-300 text-sm mb-2">
        Strive for an original and unique Channel name that distinguishes your show from others. Avoid using names that
        are too similar to existing Channels to maintain individuality and prevent confusion.</p>

    <p class="text-primary-500 font-semibold mb-1">Respect Intellectual Property:</p>
    <p class="text-primary-300 text-sm mb-2">
        Do not infringe upon the intellectual property rights of others when naming your Channel. Avoid using
        copyrighted names, trademarks, or materials without proper permission or licensing.</p>

    <p class="text-primary-500 font-semibold mb-1">Language and Tone:</p>
    <p class="text-primary-300 text-sm mb-2">
        Ensure that the Channel name uses appropriate language and tone, reflecting the professionalism and integrity
        of the Christian community. Avoid offensive or derogatory terms, and maintain a respectful approach.</p>

    <p class="text-primary-500 font-semibold mb-1">Compliance with App Guidelines:</p>

    <p class="text-primary-300 text-sm mb-2">
        Ensure that the Channel name complies with the specific guidelines set by the AtChurch app. Familiarize
        yourself with any additional naming requirements or restrictions provided by the app to avoid any conflicts or
        issues.</p>
    <p class="text-primary-300 text-sm mb-2">
        Remember, a well-crafted Channel name can significantly impact your viewership
        s success. Take the time to brainstorm, research, and choose a name that accurately represents your content,
        engages your target audience, and creates a strong brand identity.</p>

    <p class="text-primary-300 text-sm mb-2">
        In short, here are some guidelines for picking a great Channel name:</p>

    <ul class="list-disc pl-4">
        <li class="text-primary-300 text-sm mb-2">Aim for 4 words or less.</li>

        <li class="text-primary-300 text-sm mb-2">Choose a name that aligns with your content.</li>

        <li class="text-primary-300 text-sm mb-2">Keep it succinct and intriguing.</li>

        <li class="text-primary-300 text-sm mb-2">
            Try to avoid the words “The”, "Channel", "Video" and "Article"”</li>

        <li class="text-primary-300 text-sm mb-2">
            Avoid special characters, misspellings, abbreviations, and punctuation.</li>

        <li class="text-primary-300 text-sm mb-2">
            Your name should be easy to spell and pronounce.</li>

        <li class="text-primary-300 text-sm mb-2">Make sure it’s not already taken.</li>

        <li class="text-primary-300 text-sm mb-2">Gather some outside opinions.</li>

        <li class="text-primary-300 text-sm mb-2">
            Think about how your show might evolve over time.</li>

        <li class="text-primary-300 text-sm mb-2">Choose a name you like saying out loud.</li>
    </ul>
</div>
<div mat-dialog-actions class="flex flex-row justify-end w-full">
    <button mat-button
        class="bg-primary-500 text-white hover:bg-primary-700 text-sm uppercase font-bold px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
        (click)="ok()" cdkFocusInitial>Okay</button>
</div>